import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  resetAppState,
  setPlanManagementExpiredModalOpen,
} from "../../../reducers/ownApp";
import {
  resetMatrix,
  fetchDepotRouteMatrix,
  setUserSessionExpired,
} from "../../../reducers/matrixProfile/thunkActions";
import { planManagementExpiredModalOpenSelector } from "../../../reducers/ownApp/selectors";
import {
  getMatrixProfileType,
  getSelectedMatrixProfile,
} from "../../../reducers/matrixProfile/selectors";

import { Modal } from "../Modal";
import { PlanManagementExpiredContent } from "./PlanManagementExpiredContent";
import { PlanManagementExpiredActions } from "./PlanManagementExpiredActions";

export const PlanManagementExpiredModal = memo(() => {
  const dispatch = useDispatch();
  const open = useSelector(planManagementExpiredModalOpenSelector);
  const type = useSelector(getMatrixProfileType);
  const profile = useSelector(getSelectedMatrixProfile);

  const onClose = () => {
    dispatch(resetMatrix());
    dispatch(resetAppState());
  };
  const onContinue = () => {
    dispatch(setPlanManagementExpiredModalOpen(false));
    dispatch(setUserSessionExpired(false));
    dispatch(fetchDepotRouteMatrix({ profile, type }));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={"Session Expired"}
      content={<PlanManagementExpiredContent />}
      actions={
        <PlanManagementExpiredActions
          onCancel={onClose}
          onContinue={onContinue}
        />
      }
      maxWidth={"sm"}
    />
  );
});
